export default __webpack_public_path__ + "static/media/calconvert_background_l2.f5505e1f.jpg";